module.exports = __webpack_public_path__ + "static/media/social-icon-linkedin.70677f51.svg";